module.exports = __webpack_public_path__ + "static/media/icon_04.38140ba1.svg";